if (!customElements.get('linear-project-gallery')) {
  customElements.define('linear-project-gallery', class LinearProjectGallery extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-lightbox]');
      this.dialogImage = this.querySelector('[data-lightbox-image]');
      this.dialogCaption = this.querySelector('[data-lightbox-caption]');
      this.triggers = [...this.querySelectorAll('[data-lightbox-trigger]')];
      this.activeIndex = 0;

      this.triggers.forEach((trigger, index) => {
        trigger.addEventListener('click', () => this.open(index));
      });

      this.querySelector('[data-lightbox-close]')?.addEventListener('click', () => this.close());
      this.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => this.show(this.activeIndex - 1));
      this.querySelector('[data-lightbox-next]')?.addEventListener('click', () => this.show(this.activeIndex + 1));
      this.dialog?.addEventListener('click', (event) => { if (event.target === this.dialog) this.close(); });
      this.dialog?.addEventListener('cancel', () => this.close());
      this.dialog?.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') this.show(this.activeIndex + 1);
        if (event.key === 'ArrowLeft') this.show(this.activeIndex - 1);
      });
    }

    open(index) {
      this.returnFocus = document.activeElement;
      this.show(index);
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
    }

    show(index) {
      this.activeIndex = (index + this.triggers.length) % this.triggers.length;
      const trigger = this.triggers[this.activeIndex];
      const fullSrc = trigger.dataset.fullSrc || trigger.querySelector('img')?.currentSrc || trigger.querySelector('img')?.src;
      this.dialogImage.src = fullSrc;
      this.dialogImage.alt = trigger.dataset.alt || '';
      this.dialogCaption.textContent = trigger.dataset.caption || '';
      this.dialogCaption.hidden = !trigger.dataset.caption;
    }

    close() {
      this.dialog?.close();
      this.returnFocus?.focus();
    }
  });
}
